export const FETCH_CONTENTS_REQUESTED = "FETCH_CONTENTS_REQUESTED"

export const FETCH_CONTENTS_SUCCESS = "FETCH_CONTENTS_SUCCESS"

export const FETCH_CONTENTS_FAILURE = "FETCH_CONTENTS_FAILURE"

export const FETCH_CONTENTS_SEARCH_REQUESTED = "FETCH_CONTENTS_SEARCH_REQUESTED"

export const FETCH_CONTENTS_SEARCH_SUCCESS = "FETCH_CONTENTS_SEARCH_SUCCESS"

export const GENERATE_SRT_REQUESTED = "GENERATE_SRT_REQUESTED"

export const GENERATE_SRT_SUCCESS = "GENERATE_SRT_SUCCESS"

export const GENERATE_SRT_FAILURE = "GENERATE_SRT_FAILURE"

export const PING_SRT_REQUESTED = "PING_SRT_REQUESTED"

export const PING_SRT_SUCCESS = "PING_SRT_SUCCESS"

export const PING_SRT_FAILURE = "PING_SRT_FAILURE"